// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"84":"2ac8f2f8","120":"314f0ff4","332":"868194e9","491":"5227ff75","995":"ee73ee9e"}[chunkId] + ".js";
};